module.exports = "/_next/static/images/OgWarehouses-090198bd1f6249919d2191e87664f132.png";